import * as React from 'react';
import { useNavigate } from 'react-router-dom';

type RemovableEntityStore = {
  lastRemovedId: string | null;
  clearLastRemoved: () => void;
};

/**
 * Уводит с роута открытой сущности, если она была удалена.
 * Вызывать из observer-компонента: lastRemovedId читается при рендере,
 * чтобы MobX отслеживал изменение.
 */
export const useRedirectOnRemovedEntity = (
  store: RemovableEntityStore,
  openedId: string | undefined,
  indexRoute: string | null,
): void => {
  const navigate = useNavigate();
  const removedId = store.lastRemovedId;

  React.useEffect(() => {
    if (!removedId || !indexRoute || removedId !== openedId) {
      return;
    }

    store.clearLastRemoved();
    navigate(indexRoute, { replace: true });
  }, [removedId, openedId, indexRoute, navigate, store]);
};
